module.exports = __webpack_public_path__ + "img/meguru01_end.aefdb432.png";